import { OrganizationFeature } from '../interfaces/organization';

export const isComplianceRegionUS = (features: OrganizationFeature[]) => {
  return !features.includes(OrganizationFeature.ComplianceUK) && !features.includes(OrganizationFeature.ComplianceAUS);
};
